<template>
  <div class="app-container">
    <div v-if="hasAddOperation" class="add">
      <el-row :gutter="20">
        <el-col :span="6"
          ><el-input
            v-model="listQuery.keyword_search"
            placeholder="输入要搜索的内容"
            clearable
            @clear="getList()"
          ></el-input
        ></el-col>
        <el-col :span="2"><el-button type="primary" @click="getList()">搜索</el-button> </el-col>
        <el-col :span="10">&nbsp;</el-col>
        <el-col :span="6" style="text-align: right">
          <el-button type="primary" icon="el-icon-plus" @click="addRoleClick">新建角色</el-button></el-col
        >
      </el-row>
    </div>
    <br />
    <el-table v-loading="listLoading" :data="list" border>
      <el-table-column align="center" prop="id" label="id" />
      <el-table-column align="center" prop="title" label="角色名" />
      <el-table-column align="center" prop="intro" label="权限说明">
        <template v-if="scope.row.intro" slot-scope="scope">
          <el-popover placement="top-start" width="200" trigger="hover" :content="scope.row.intro">
            <p slot="reference" class="pai">
              {{ scope.row.intro }}
            </p>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="admin_auth_group_update_time" label="最后修改时间">
        <template slot-scope="scope">
          {{ scope.row.admin_auth_group_update_time || scope.row.create_time }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="200">
        <template slot-scope="scope">
          <el-button v-if="hasEditOperation" type="primary" size="small" @click="handleEditClick(scope.row)"
            >编辑</el-button
          >
          <el-button v-if="hasDeleteOperation" type="danger" size="small" @click="handleDeleteClick(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="page">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page_index"
        :limit.sync="listQuery.page_size"
        @pagination="getList"
      />
    </div>

    <el-drawer
      ref="drawer"
      :title="form.id ? '编辑身份' : '新增身份'"
      :visible.sync="showMdal"
      direction="rtl"
      custom-class="drawer"
    >
      <div class="drawer-content">
        <el-form :model="form">
          <el-form-item label="身份名称" :label-width="formLabelWidth">
            <el-input v-model="form.title" autocomplete="off" />
          </el-form-item>
          <el-form-item label="权限说明" :label-width="formLabelWidth">
            <el-input v-model="form.intro" autocomplete="off" />
          </el-form-item>
          <el-form-item id="treeWrapper" class="manage-module" label="管理模块" :label-width="formLabelWidth">
            <el-scrollbar :style="{ height: treeWrapper + 'px' }">
              <el-tree
                ref="tree"
                :data="authList"
                show-checkbox
                node-key="id"
                :default-checked-keys="checked"
                :default-expanded-keys="expanded"
                :props="defaultProps"
              />
            </el-scrollbar>
          </el-form-item>
        </el-form>
        <div class="drawer-footer">
          <el-button class="btn" @click="cancelForm">取 消</el-button>
          <el-button class="btn" type="primary" :loading="submitLoading" @click="onSubmitClick">{{
            submitLoading ? "提交中 ..." : "保 存"
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { getRoleList, saveRole, editRole, deleteRole, getRoleDetail } from "@/api/auth";
import { menulist } from "@/api/common";
import Pagination from "@/components/Pagination";
import operations from "../../mixins/operations";
function getCheckedAuthList(list, checked = [], expanded = []) {
  // 通过authList筛选出checked的最小选项
  for (const item of list) {
    if (!item.son_rule || !item.son_rule.length) {
      checked.push(item.id);
      expanded.push(item.fid);
    } else {
      if (item.son_rule) {
        getCheckedAuthList(item.son_rule, checked, expanded);
      }
    }
  }
  return { checked, expanded };
}

export default {
  components: { Pagination },
  mixins: [operations],
  data() {
    return {
      list: [],
      total: 0,
      listQuery: {
        page_index: 1,
        page_size: 10,
      },
      listLoading: true,
      showMdal: false,
      formLabelWidth: "80px",
      authList: [],
      form: {
        title: "",
        permission: "",
      },
      submitLoading: false,
      checked: [],
      expanded: [],
      defaultProps: {
        label: "menu_name",
        children: "son_rule",
      },
      editId: null,
      editLoading: false,
      treeWrapper: 0,
    };
  },
  computed: {
    hasAddOperation() {
      return this.operations.includes("新建角色");
    },
    hasEditOperation() {
      return this.operations.includes("编辑角色");
    },
    hasDeleteOperation() {
      return this.operations.includes("删除角色");
    },
  },
  watch: {
    showMdal: function (val) {
      if (val) {
        this.setHeight();
      }
    },
  },
  async mounted() {
    this.getList();
    const authList = await menulist().catch((error) => {
      throw error;
    });

    this.authList = authList;
    console.log(this.operations);
  },
  methods: {
    async getList(params = this.listQuery) {
      this.listLoading = true;
      const { total, data } = await getRoleList(params).catch((error) => {
        throw error;
      });
      this.listLoading = false;

      this.total = total;
      this.list = data;
    },
    async handleEditClick(row) {
      this.form = row;
      if (this.$refs.tree) {
        this.$refs.tree.setCheckedKeys([]);
      }
      const id = row.id;
      this.editId = id;
      const { group } = await getRoleDetail(id).catch((error) => {
        this.editLoading = false;
        throw error;
      });
      const { rules } = group;
      rules.map((item) => {
        item = item - 0;
      });
      // console.log(rule_tree)
      console.log(group);
      // const { checked, expanded } = getCheckedAuthList(rules);
      this.checked = rules;
      // this.checked = checked;
      this.expanded = rules;
      this.form.title = row.title;
      this.showMdal = true;
    },
    addRoleClick() {
      this.form = {};
      this.editId = null;
      this.checked = [];
      this.expanded = [];

      this.showMdal = true;
      if (this.$refs.tree) {
        this.$refs.tree.setCheckedKeys([]);
      }
    },
    handleDeleteClick(id) {
      this.$confirm(`是否删除该身份？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await deleteRole(id);
        this.getList();
        this.$notify({ title: "操作成功", type: "success" });
      });
    },
    onDrawerClose() {
      this.showMdal = false;
    },
    setHeight() {
      this.$nextTick(() => {
        if (!document.getElementById("treeWrapper")) return;
        this.treeWrapper = document.getElementById("treeWrapper").getBoundingClientRect().height;
      });
    },
    async onSubmitClick() {
      const checked = this.$refs.tree.getCheckedNodes();
      const checkedHalf = this.$refs.tree.getHalfCheckedNodes(); // 后台要求半选的父级也需要传
      const rules_url = [...checked.map((item) => item.menu_url), ...checkedHalf.map((item) => item.menu_url)];
      const rules = [...checked.map((item) => item.id), ...checkedHalf.map((item) => item.id)];

      const rules_name = [...checked.map((item) => item.menu_name), ...checkedHalf.map((item) => item.menu_name)];
      const title = this.form.title;
      const intro = this.form.intro;
      if (!this.form.title) {
        return this.$notify.error({
          title: "错误",
          message: "请填写身份名称",
        });
      }
      if (!checked.length) {
        return this.$notify.error({
          title: "错误",
          message: "请选择至少一个权限",
        });
      }
      this.submitLoading = true;
      const id = this.editId;

      const data = {
        title,
        intro,
        rules_url,
        rules,
        rules_name,
      };
      if (!id) {
        await saveRole(data).catch((error) => {
          this.submitLoading = false;
          throw error;
        });
      } else {
        data.id = id;
        await editRole(id, data).catch((error) => {
          this.submitLoading = false;
          throw error;
        });
      }

      this.$notify({ title: "操作成功", type: "success" });
      this.editId = null;
      this.submitLoading = false;
      this.$refs.drawer.closeDrawer();
      this.getList();
    },
    cancelForm() {
      this.showMdal = false;
    },
  },
};
</script>
<style lang="less" scoped>
.pai {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.drawer-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  .manage-module {
    height: 100%;
    .el-form-item__content {
      height: 100%;
    }
    .el-tree {
      min-width: 100%;
      display: inline-block !important;
      margin-top: 8px;
    }
  }

  .el-form {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .el-scrollbar {
    overflow-x: hidden;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  .drawer-footer {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    .btn {
      width: 50%;
    }
  }
}
</style>
